export function checkoutPlanIds({ items = [], scheduledItems = [], finishableBundle = null } = {}) {
  const ids = [];
  const seen = new Set();
  const add = (value) => {
    const id = value || null;
    if (!id || seen.has(id)) return;
    seen.add(id);
    ids.push(id);
  };

  // Completed work is authoritative for this checkout. Once a procedure visit
  // is recorded, it may disappear from scheduled_items while its persisted
  // checkout row still carries the treatment plan that must receive payment.
  for (const item of Array.isArray(items) ? items : []) add(item?.treatment_plan_id);
  for (const item of Array.isArray(scheduledItems) ? scheduledItems : []) add(item?.treatment_plan_id);
  add(finishableBundle?.plan_id);

  return ids;
}

export function primaryCheckoutPlanId(input) {
  return checkoutPlanIds(input)[0] || null;
}
